import React, { useState, useEffect } from "react";
import "../all css/homemain.css";
import Navbar from "../../components/navbar/Navbar";
import Herohomesection from "./Herohomesection";
import StudyDestination from "./StudyDestination";
import NewsUpdates from "./NewsUpdates";
import VideoCounselling from "./VideoCounselling";
import CountingSection from "./CountingSection";
import TestimonialSection from "./TestimonialSection";
import InterestedSection from "./InterestedSection";
import Footer from "../../components/footer/footer";
import { WhatToDoSection } from "./WhatToDoSection";
import LogosOfUnivercity from "./LogosOfUnivercity";
import { MdCall } from "react-icons/md";
import WOW from "wowjs";

function Home(props) {
  const [openInterestedForm, setOpenInterestedForm] = useState(false);
  const [hoverBtn, setHoverBtn] = useState(false);

  useEffect(() => {
    new WOW.WOW({
      animateClass: "animated",
      offset: 160,
      callback: function (box) {},
    }).init();
  }, []);

  function handleFloatingInterested() {
    setOpenInterestedForm(!openInterestedForm);
  }
  function handleShowText() {
    setHoverBtn(true);
  }

  return (
    <>
      <div className="home_main_container">
        <div className="nav_container">
          <Navbar fromPage="home" />
        </div>
        <Herohomesection />
        <WhatToDoSection />
        <CountingSection />
        <StudyDestination />
        <NewsUpdates />
        <LogosOfUnivercity />

        <VideoCounselling />
        <TestimonialSection />

        <InterestedSection toggleDialog={openInterestedForm} />
        <Footer />
      </div>
      <div className="floating_icon_container1">
        <button
          onClick={handleFloatingInterested}
          onMouseEnter={handleShowText}
          onMouseLeave={() => setHoverBtn(false)}
        >
          E<br />
          n<br />q<br />u<br />i<br />r<br />e<br />
          <br /> n<br />o<br />w<br />
        </button>
      </div>
      {/* 
    <div className="floating_icon_container">
    <button onClick={() => handleContactClick(true)}>
    <MdPhoneAndroid className="icon_floating_self" />
    Contact Us
    </button>
  </div> */}
    </>
  );
}

export default Home;
